<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/vip")
          i.fas.fa-crown
          span.ml-1 {{ $t("ui.vip") }}
      b-breadcrumb-item(v-if="selectedVipId != null && pageLvl != 'vip'")
        span.ml-1 {{ selectedVipId }}
  div.row
    div.col-md-12
      div.card
        div.card-body
          div(v-if="pageLvl == 'vip'")
            div.row.clusterize
              div.col-md-12
                .clusterize-scroll
                  table.tablex(style="width: 35%;")
                    thead
                      tr
                        th.sticky-position(width="5%")
                          span #
                        th.sticky-position(width="30%")
                          span(:title="$t('ui.vip_id')") {{ $t('ui.vip_id') }}
                        th.sticky-position(width="40%")
                          span(:title="$t('ui.vip_name')") {{ $t("ui.vip_name") }}
                    tbody.clusterize-content
                      tr(v-if="vipList.length == 0")
                        td(colspan="3").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in vipList")
                        td
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.vip_id")
                            b-link.clickable(href="javascript:void(0);" @click="setVipId(item)") {{ item.vip_id }}
                        td
                          span(:title="item.vip_name") {{ item.vip_name }}
          div(v-if="pageLvl == 'vipProvider' && selectedVipId != null")
            div.mb-1
              SubmitButton(
                :loading="loading"
                icon="icon-arrow-left"
                :text="$t('ui.back')"
                type="button"
                @click="backToVipList"
                variant="secondary"
                size="sm"
                ).mb-1.mr-1
            div.row.clusterize
              div.col-md-12
                .clusterize-scroll
                  table.tablex(style="width: 50%;")
                    thead
                      tr
                        th.sticky-position(width="5%")
                          span #
                        th.sticky-position(width="15%")
                          span(:title="$t('ui.provider_code')") {{ $t('ui.provider_code') }}
                        th.sticky-position(width="25%")
                          span(:title="$t('ui.provider_name')") {{ $t('ui.provider_name') }}
                        th.sticky-position(width="20%")
                          span(:title="$t('ui.self_rebate_rate')") {{ $t("ui.self_rebate_rate") }}
                        th.sticky-position(width="20%")
                          span(:title="$t('ui.downline_rebate_rate')") {{ $t("ui.downline_rebate_rate") }}
                        th.text-center.sticky-position(width="10%")
                          span(:title="$t('ui.action')") {{ $t("ui.action") }}
                    tbody.clusterize-content
                      tr(v-if="vipProviderList.length == 0")
                        td(colspan="6").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in vipProviderList")
                        td
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.provider_code") {{ item.provider_code }}
                        td
                          span(:title="item.provider_name") {{ item.provider_name }}
                        td
                          span(:title="item.self_rebate_rate") {{ item.self_rebate_rate }}
                        td
                          span(:title="item.downline_rebate_rate") {{ item.downline_rebate_rate }}
                        td.actions
                          span
                            a.fa.fa-edit.text-primary(href="javascript:void(0)" @click="onEditVipProvider(item)" :title="$t('ui.edit')")
    editvipprovider(ref="editvipprovider" :vipId="selectedVipId" :item="selectedVipProvider" @clicked="afterEditVipProvider" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import { required, minLength, maxLength, alphaNum, integer, email, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";
import editvipprovider from "@/components/vip/editVipProvider.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    editvipprovider
  },
  data: () => ({
    loading: false,
    vipList: [],
    vipProviderList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    selectedVipProvider: null,
    selectedVipId: null,
    pageLvl: "vip"
  }),
  computed: {
    getAccountId() {
      return this.$store.getters.accountId;
    }
  },
  mounted: function() {
    this.pageLvl = 'vip';
    this.getVipList();
  },
  methods: {
    backToVipList() {
      this.pageLvl = "vip";
      this.selectedVipId = null;
      this.getVipList();
    },
    setVipId: function (e) {
      this.selectedVipId = e.vip_id;
      this.getVipProviderList();
    },
    onEditVipProvider(e) {
      this.selectedVipProvider = e;
      this.$refs.editvipprovider.$refs.editVipProvider.show();
    },
    afterEditVipProvider: function() {
      this.getVipProviderList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_vip_provider"), this.$t("message.success"), "success");
    },
    getVipList: function() {
      let url = config.vipLookupUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.pageLvl = "vip";
                if (response.data.dt.length > 0) {
                  this.vipList = response.data.dt;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getVipProviderList: function() {
      let url = config.vipProviderListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        vip_id: this.selectedVipId,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.pageLvl = "vipProvider";
                if (response.data.dt.length > 0) {
                  this.vipProviderList = response.data.dt;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>